import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';

import { GenericFilterParameter } from '../../../models/generic-comunication-cmp';
import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { GenericExternalCommandType } from '../../../models/generic-external-command';
import { FindContribuenteTableField } from '../../../models/library-table-field';
import { GenericTableField } from '../../../models/generic-table-field';
import { Person } from '../../../models/person';

@Component({
    selector: 'app-find-contribuente',
    templateUrl: './find-contribuente.component.html',
    styleUrls: ['./find-contribuente.component.css']
})
export class FindContribuenteComponent extends AppComponentGenericComponent implements OnInit  {
  @Output() innerEvents = new EventEmitter();

  //	Table
  tableFields: FindContribuenteTableField;
  headerFields: GenericTableField[];
  footerFields: GenericTableField[];
  ngClassRow = "";

  //	FilterBox
  contribuentiPratiche: any[] = [];
  contribuentiFiltered: any[] = [];
  contribuentiFilteredSubmit: any[] = [];

  contribuenti: Person[] = [];
  anagraficaSync: Subscription;

  praticheFiltered: any[] = [];
  pratiche: any[] = [];
  praticheSync: Subscription;
  externCommands: Map<string, GenericExternalCommandType> = null;

  constructor(protected dataService: DataService) {
      super(dataService, 'find-contribuente');
  }

  ngOnInit() {
      //console.log('DATA INNER FIND CONTRIBUENTE', this.data);
      this.tableFields = new FindContribuenteTableField();
      this.headerFields = this.tableFields.getHeader();
      this.footerFields = this.tableFields.getFooter();

      this.parametri = new GenericFilterParameter();
      this.parametri.setTypeFilter("find-contribuente");
      this.parametri.setTitleBox("Cerca Contribuente");
      this.parametri.setNumFilteredTxt("Posizioni");
      this.parametri.setDataArraySource(this.contribuentiPratiche);
      this.externCommands = new Map();
      if(this.checkPermission('global','write')){
	  let externCommandLocal = new GenericExternalCommandType();
	  this.parametri.setWritePermission(true);
      }
      this.parametri.setExternCommands(this.externCommands);
      this.updateParametri();

      this.anagraficaSync = this.dataService.getContribuentiService().anagrafica$.subscribe(
	  anagrafica => {
	      this.contribuenti = anagrafica;
	      if(this.contribuenti.length && this.pratiche.length){
		this.riempiContribuentiPratiche();
	      }
	  });
      this.praticheSync = this.dataService.pratiche$.subscribe(
	  pratiche => {
	      this.pratiche = pratiche;
	      if(this.contribuenti.length && this.pratiche.length){
		this.riempiContribuentiPratiche();
	      }
	  });
  }

  ngOnChanges(changes: any){
      console.log('CMP|FIND-PRATICHE - CHANGE',  changes);
      if(changes.parametri){
	  this.updateParametri();
      }
  }

  updateParametri(){
      console.log('CMP|FIND-CONTRIBUENTE - CHANGE FIND-CONTRIBUENTE UPDATEPARAMETRI', this.parametri);
      this.parametriString = this.parametri.generateParametriToString();
      //this.cdr.markForCheck();
      //console.log('CHANGE FIND-CONTRIBUENTE UPDATEPARAMETRISTRING', this.parametriString);
  }

  manageEventFilterBox($event){
      //console.log("manageEventFilterBox", $event);
      if($event){
	  switch($event.type){
	      case 'filterResult':
		  this.contribuentiFilteredSubmit = ($event.data) ? $event.data : [];
		  break;
	      default:
		  console.log("type non riconosciuto!");
	  }
      }
  }

  apriModifica($event){
    //console.log("apriModifica", $event);
    this.selezionaPersona($event);
  }

  apriNuovo(){
  }

  riempiContribuentiPratiche(){
    this.contribuentiPratiche = [];
    let contribuenteLocal: any = {};

    for(let contribuente of this.contribuenti){
      contribuenteLocal = {};
      contribuenteLocal.anagrafica_id = Number(contribuente.anagrafica_id);
      contribuenteLocal.codice_fiscale = contribuente.codice_fiscale;
      contribuenteLocal.nominativo = contribuente.cognome;
      if(contribuente.nome){
	contribuenteLocal.nominativo = contribuenteLocal.nominativo.concat(" ");
	contribuenteLocal.nominativo = contribuenteLocal.nominativo.concat(contribuente.nome);
      }
      contribuenteLocal.indirizzo_completo = contribuente.indirizzo_completo;
      contribuenteLocal.comune = contribuente.comune;
      contribuenteLocal.prov = contribuente.prov;
      contribuenteLocal.cap = contribuente.cap;
      contribuenteLocal.pratiche = [];
      for(let pratica of this.pratiche){
	if(contribuente.anagrafica_id == pratica.anagrafica_id){
	  contribuenteLocal.pratiche.push(Number(pratica.id_prat));
	}
      }
      //console.log("contribuenteLocal", contribuenteLocal);
      /*contribuenteLocal.actions = {
	title: "Aggiungi",
	icon: "add",
	disabled: !this.writePermission,
      };*/
      contribuenteLocal.actions = {
	title: "Seleziona",
	icon: "arrow_forward",
	disabled: false,
      };
      this.contribuentiPratiche.push(contribuenteLocal);
    }
    console.log("contribuentiPratiche", this.contribuentiPratiche);
    this.parametri.setDataArraySource(this.contribuentiPratiche);
    this.updateParametri();
  }

  selezionaPersona(contribuente: Person){
      let event = {
	  hide: true,
	  innerFind: true,
	  content: contribuente,
      }

      this.innerEvents.emit(event);
  }

  ngOnDestroy() {
      this.anagraficaSync.unsubscribe();
      this.praticheSync.unsubscribe();
      //this.resetFilter();
  }
}
